// extracted by mini-css-extract-plugin
export var chevron = "_oy-1";
export var clickable = "_oy-0";
export var ruleRow = "_oy-2";